import React from 'react';
import { Popover, Button, TextContent } from '@cloudscape-design/components';

interface TooltipProps {
  content: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  size?: 'small' | 'medium' | 'large';
}

const Tooltip: React.FC<TooltipProps> = ({
  content,
  position = 'top',
  size = 'small',
}) => {
  return (
    <Popover
      dismissButton={false}
      position={position}
      size={size}
      triggerType="custom"
      content={
        <TextContent>
          <p>{content}</p>
        </TextContent>
      }
    >
      <Button iconName="status-info" variant="icon" />
    </Popover>
  );
};

export default Tooltip;
